import React ,{useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import {
    ValidationTextField,
} from '../../styling/Styles';
import {checkIfAppNameExists, checkIfAppNameHasSpaces} from '../../validations/validations'

function GetStepContent(step,isEdit) {
    const [appName, setAppName] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [typeApp, setTypeApp] = React.useState('web_application');
    const [colorTheme, setColorTheme] = React.useState('#760209');
    const [fontType, setFontType] = React.useState('classic');
    const [invitedlist, setInvitedlist] = React.useState([]);
    const [currentId, setCurrentId] = React.useState(-1);
    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [selectedDuplicatedProject, setSelectedDuplicatedProject] = React.useState('none');
  
    const location = useLocation();
  

    useEffect(() => {

      if (isEdit === true) {
        setAppName(location.state.project.name);
        setDescription(location.state.project.description);
        setTypeApp(location.state.project.type_app);
        setColorTheme(location.state.project.color_theme);
        setFontType(location.state.project.type_font);
        setInvitedlist(location.state.project.invited_people);
        setCurrentId(location.state.project._id);
      }
    }, [isEdit]);

    useEffect( () => {

      if(open === false){
        const tempData = JSON.parse(localStorage.getItem('data'));
        setSelectedDuplicatedProject('none');
        setData(tempData);        
        setOpen(true);
      }

    },[open])
  
    let display;
  
    const returnHelperText = () => {
      if(appName === ''){
        return 'Required field.';
      }
      if(checkIfAppNameExists(isEdit,currentId,appName) === true){
        return 'Name already exists';
      }
      if(checkIfAppNameHasSpaces(appName) === true){
        return 'App name has spaces';
      }
      return null;
      
    }

    if(step === 0) {
        display = (
          <div>
            <div className={clsx('boldBlue')}>*Project name</div>
            <div className={clsx('spacingTopDiv')}>
              <ValidationTextField
                id='appNameInput'
                onInput={(e) => setAppName(e.target.value)}
                value={appName}
                aria-label="empty textarea"
                label="Project name"
                InputLabelProps={{ style: { fontFamily: 'Open Sans' } }}
                variant="outlined"
                helperText={ returnHelperText()}
                error={
                  (appName === '' )
                  || (checkIfAppNameExists(isEdit,currentId,appName) === true ) || checkIfAppNameHasSpaces(appName) === true
                }
                style={{ width: '100%' }}
              />
            </div>
            <div className={clsx('spacingTopDiv')}>
              <div className={clsx('boldBlue')}> *Description </div>
            </div>
            <div className={clsx('spacingTopDiv')}>
              <ValidationTextField
                id='descriptionInput'
                variant="outlined"
                onInput={(e) => setDescription(e.target.value)}
                value={description}
                label="Description"
                InputLabelProps={{ style: { fontFamily: 'Open Sans' } }}
                helperText={description === ''  ? 'Required field.' : null}
                error={description === ''}
                multiline
                rows={4}
                style={{ width: '100%' }}
              />
            </div>
            <SelectDuplicateProject location={location} data={data} selectedDuplicatedProject={selectedDuplicatedProject} setSelectedDuplicatedProject={setSelectedDuplicatedProject}/>
          </div>
        );
        return [
          display,
          appName,
          description,
          typeApp,
          colorTheme,
          fontType,
          invitedlist,
          selectedDuplicatedProject
        ];
      }
      display = (
        <div className={clsx('spacingDown', 'spacingTop')}>
          <div className={clsx('boldBlue')}>Your choices are:</div>
          <div style={{ marginLeft: '1vw' }} className={clsx('lightBlue')}>
            <div style={{ marginTop: '1vw' }}>
              App name:
              {' '}
              <span style={{ color: 'black' }}>
                {' '}
                {appName}
                {' '}
              </span>
            </div>
            <div style={{ marginTop: '1vw' }}>
              Description:
              {' '}
              <span style={{ color: 'black' }}>
                {' '}
                {description}
              </span>
            </div>
            { location.state.reason === 'duplicate' &&
              <div style={{ marginTop: '1vw' }}>
                Duplicate project based on:
                {' '}
                <span style={{ color: 'black' }}>
                  {' '}
                  {selectedDuplicatedProject}
                </span>
              </div>
            }
          </div>
        </div>
      );
      return [
        display,
        appName,
        description,
        typeApp,
        colorTheme,
        fontType,
        invitedlist,
        selectedDuplicatedProject
      ];
  }

const SelectDuplicateProject = (props) => {

  const{
    location,
    data,
    selectedDuplicatedProject,
    setSelectedDuplicatedProject
  } = props;


  return(
      ( location.state.reason === 'duplicate' &&
        <div className={clsx('spacingTopDiv')}>
          <div className={clsx('boldBlue')}>*Duplicate project</div>

          <div style={{display: 'flex', flexDirection: 'row', marginTop: '1rem'}}>
            <div style={{alignSelf: 'center'}}> Based on: &nbsp;&nbsp;</div>

            <div className="dropdown">
                <button className={clsx('btn dropdown-toggle','dropdown-button','dropdown-button-color')} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {selectedDuplicatedProject}
                </button>
                <div className="dropdown-menu scrollable-menu" style={{maxHeight: '250px', overflowX: 'hidden'}} aria-labelledby="dropdownMenuButton">
                    {data.map( (project) => project.name).map( (projectName) => (
                      <button type='button' key={projectName} className={clsx('dropdown-item', 'teamSelector','styleDropDown3')} aria-hidden="true" onClick={() => {setSelectedDuplicatedProject(projectName)}}>{projectName} </button>
                      ))
                    }
                </div>
            </div>
          </div>
          { selectedDuplicatedProject === 'none' &&
            <span className={clsx('MuiFormHelperText-root','Mui-error','MuiFormHelperText-contained')} style={{color: '#f44336'}}> Required field.</span>
          }
        </div>
      )
  )

}

export default GetStepContent;